var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VBtn',_vm._g(_vm._b({staticClass:"base-btn-change",attrs:{"color":"white","outlined":"","small":""}},'VBtn',_vm.$attrs,false),_vm.$listeners),[_c('VIcon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" Zmień ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }